<div class="experiencesFilters sticky">
  <div class="searchbarExperiences">
    <!--search 0-->
    <div class="searchBox">
      <p-autoComplete
        placeholder="Dove vuoi andare?"
        [(ngModel)]="searchText"
        class="filterExperience noBorderInput"
        [suggestions]="filteredWhere"
        (completeMethod)="filterWhere($event)"
        field="name"
        (onClear)="changeSearchTextWhereClear()"
        (onSelect)="changeSearchTextWhere($event)"
      >
            <ng-template let-res pTemplate="item">
              <div class="location-item">
                <div class="location-content">
                  <div class="location-icon">
                    <img [src]="res.icon" alt="location" />
                  </div>
                  <div class="location-info">
                    <div class="location-name">{{ res.name }}</div>
                    <div class="location-type">{{ getTypeLabel(res.type) }}</div>
                  </div>
                </div>
                <div
                  *ngIf="res.numExperiences && res.numExperiences > 0"
                  class="location-count"
                >
                  {{ res.numExperiences }} {{ res.numExperiences === 1 ? 'esperienza' : 'esperienze' }}
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="footer">
              <div class="location-footer">
                <a href="#" class="location-nearby" (click)="$event.preventDefault()">
                  Esperienze intorno a me
                </a>
              </div>
            </ng-template>
          </p-autoComplete>
          <i class="pi pi-search"></i>
        </div>
    <p-divider layout="vertical" />
    <!--calendar 1-->
    <div class="searchBox" style="position: relative">
      <input
        style="background: none; border: none"
        type="button"
        (click)="calendarPopUp.toggle($event)"
        [ngModel]="datesText"
      />
      <p-overlayPanel #calendarPopUp styleClass="position:absolute;">
        <p-calendar
          [(ngModel)]="rangeDates"
          selectionMode="range"
          inputId="icondisplay"
          [showTime]="false"
          [readonlyInput]="true"
          placeholder="Data o Periodo"
          inline="true"
          [minDate]="minDate"
        ></p-calendar>
      </p-overlayPanel>

      <p-inputIcon
        [styleClass]="iconCalendar"
        (click)="fieldReset(1)"
        (click)="calendarPopUp.toggle($event)"
      />
    </div>
    <p-divider layout="vertical" />
    <!--Persone 2-->
    <div class="searchBox">
      <input
        style="background: none; border: none"
        [ngModel]="numPersone"
        type="button"
        (click)="personPopUp.toggle($event)"
      />
      <p-inputIcon [styleClass]="iconPerson" 
      (click)="fieldReset(2)"
      (click)="personPopUp.toggle($event)"/>
      <p-overlayPanel #personPopUp>
        <div style="display: flex; flex-direction: row">
          <div style="padding-right: 3rem">
            <p>Persone</p>
            <p style="font-size: small">Seleziona il numero</p>
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <p-inputNumber
              [(ngModel)]="numPax"
              [showButtons]="true"
              buttonLayout="horizontal"
              placeholder=0
              inputId="horizontal"
              inputStyleClass="miroInput"
              spinnerMode="horizontal"
              [step]="1"
              decrementButtonClass="miroButtons"
              incrementButtonClass="miroButtons"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              min="1"
              [max]="numberOfExperiences"
            />
          </div>
        </div>
      </p-overlayPanel>
    </div>
    <p-divider layout="vertical" />
    <!--Prezzo 3-->
    <div class="searchBox">
      <input
      style="background: none; border: none"
      [ngModel]="pricePopUpText"
      type="button"
      (click)="pricePopUp.toggle($event)"
      />

      <p-inputIcon [styleClass]="iconPrice" 
      (click)="fieldReset(3)"
      (click)="pricePopUp.toggle($event)"/>
      <p-overlayPanel #pricePopUp (onHide)="confirmPrice($event)">
        <div style="display: flex; flex-direction: row">
          <div>
            <p>Minimo</p>
            <span>
              €
              <input type="text" [ngModel]="priceRangeValues[0]" />
            </span>
          </div>
          <p-divider layout="vertical" />
          <div>
            <p>Massimo</p>              
            <span>
              €
              <input type="text" [ngModel]="priceRangeValues[1]"/>
            </span>
          </div>
        </div>
      </p-overlayPanel>
    </div>
    <p-divider layout="vertical" />
    <!--Lingua 4-->
    <div class="searchBox">
      <p-multiSelect
        [options]="langs"
        [(ngModel)]="selectedLangs"
        (onPanelHide)="doFilter()"
        class="filterExperience noBorderInput"
        [filter]="true"
        placeholder="Lingua"
        optionLabel="name"
      >
      </p-multiSelect>
    </div>
    <p-divider layout="vertical" />
    <!--Servizi 5-->
    <div class="searchBox">
      <p-multiSelect
        [options]="services"
        [(ngModel)]="selectedServices"
        class="filterExperience noBorderInput"
        (onPanelHide)="doFilter()"
        [filter]="true"
        placeholder="Servizi"
        optionLabel="name"
      >
        <ng-template let-service pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ service.name }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>

  <div class="filterLineTwo">
    <div
      class="singleTypeCont flex"
      (click)="toogleType(type)"
      *ngFor="let type of types"
      [ngClass]="{ isTagActive: isActive(type) }"
    >
      <img [src]="type.icon" class="singleTypeImg" />
      <span class="singleTypeLabel">{{ type.name }}</span>
    </div>
  </div>
</div>
<div *ngIf="!showMap" class="grid experienceGrid pt-5 pm-5" [style]="{ width: '100%' }">
  <div
    *ngFor="let card of experiecesCards"
    class="sm:col-12 md:col-6 lg:col-4 xl:col-3"
  >
    <app-experience-card
      [experience]="card"
      (click)="linkToExperience(card.id, card.details?.title || card.title || '')"
    ></app-experience-card>
  </div>
  <div
    *ngFor="let card of experiecesCardsEmtpy"
    class="sm:col-12 md:col-6 lg:col-4 xl:col-3"
  >
    <app-experience-card [experience]="undefined"></app-experience-card>
  </div>
  <div
    *ngIf="experiecesCards.length == 0 && experiecesCardsEmtpy.length == 0"
    class="col-12 flex align-items-center justify-content-center noDataContainer"
  >
    <span class="noDataText text-4xl font-italic" i18n
      >Nessun esperienza trovata</span
    >
  </div>
  <div class="showMoreBar" *ngIf="showMoreButtonVisible">
    <p-button class="divineaButton" (onClick)="showMore()" i18n
      >Carica altre ({{ showMoreNumber }})</p-button
    >
  </div>
  <p-scrollTop></p-scrollTop>
</div>

<app-experiences-map
  *ngIf="showMap"
  [cards]="experiecesCards"
  (clickOnExperience)="clickOnExperienceMap($event)"
  (moveMapEvent)="changeMapBounding($event)"
></app-experiences-map>

<div class="mostraToogleButton">
  <p-button (onClick)="toogleMap()" *ngIf="this.showMap" class="divineaButton"
    >Mostra Elenco</p-button
  >
  <p-button (onClick)="toogleMap()" *ngIf="!this.showMap" class="divineaButton"
    >Mostra Mappa</p-button
  >
</div>
